module.exports = __webpack_public_path__ + "img/mercantil.7553427c.jpg";